import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsGroupPipe } from './is-group.pipe';
import { GroupColorPipe } from './group-color.pipe';
import { GetExercisePipe } from './get-exercise.pipe';
import { PlanDetailsPipe } from './plan-details.pipe';
import { FirestoreTimestampPipe } from './firestore-timestamp.pipe';
import { LatestExerciseHistoryPipe } from './latest-exercise-history.pipe';
import { FetchExerciseImagePipe } from './fetch-exercise-image.pipe';
import { GetPrPipe } from './get-pr.pipe';
import { AuthStatePipe } from './auth-state.pipe';
import { ElapsedTimePipe } from './ellapsed-time.pipe';

const pipes = [
  IsGroupPipe,
  GroupColorPipe,
  GetExercisePipe,
  PlanDetailsPipe,
  FirestoreTimestampPipe,
  LatestExerciseHistoryPipe,
  FetchExerciseImagePipe,
  GetPrPipe,
  AuthStatePipe,
  ElapsedTimePipe,
];

@NgModule({
  declarations: pipes,
  imports: [CommonModule],
  exports: pipes,
})
export class SharedPipesModule {}
